import React from "react";
import { Link } from "react-router-dom";
import { serviceSlugByName } from "../data/servicePages";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h1>Pressure Washing Services In Clinton, NC</h1>
          <p>
            Professional pressure washing and soft washing services for homes and businesses in
            Clinton, NC and surrounding communities.
          </p>
        </div>
        <div className="row services-grid">
          {props.data
            ? props.data.map((d, i) => {
                const serviceSlug = serviceSlugByName[d.name];
                const servicePath = serviceSlug ? `/services/${serviceSlug}` : "/services";

                return (
                  <div key={`${d.name}-${i}`} className="col-sm-6 col-md-4 service-col">
                    <Link
                      to={servicePath}
                      className="service-card-link"
                      aria-label={`Learn more about ${d.name} services in Clinton, NC`}
                    >
                      <div className="service-card">
                        <i className={d.icon}></i>
                        <div className="service-desc">
                          <h3>{d.name}</h3>
                          <p>{d.text}</p>
                          <span className="service-card-cta">Learn more</span>
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })
            : "loading"}
        </div>
        <div className="services-location-cta">
          <p>
            Looking for pressure washing outside Clinton? Explore our nearby{" "}
            <Link to="/service-areas">service area pages</Link>.
          </p>
        </div>
      </div>
    </div>
  );
};
